import {useTranslation} from 'react-i18next'
import {components} from 'react-select'

const CustomMenuList = (props: any) => {
  const {children, selectProps} = props
  const {t} = useTranslation()

  if (!selectProps.isMulti) {
    return <components.MenuList {...props}>{children}</components.MenuList>
  }

  return (
    <div>
      <div
        style={{
          padding: '8px',
          borderBottom: '1px solid #eee',
          background: 'white',
          position: 'sticky',
          top: 0,
          zIndex: 10,
        }}
      >
        <div className='d-flex gap-2'>
          <button
            className='btn btn-primary btn-sm w-25 fw-bold'
            onClick={selectProps.confirmHandler}
            title={t('VALIDATION.SELECT_', {name: ''})}
          >
            <span className='fa fa-check mx-1'></span>
          </button>

          <button
            className='btn btn-danger btn-sm w-25 fw-bold'
            onClick={selectProps.cancelHandler}
            title={t('BUTTONS.CANCEL')}
          >
            <span className='fa fa-times mx-1'></span>
          </button>

          <button
            className='btn btn-success btn-sm w-25 fw-bold'
            onClick={selectProps.selectAllHandler}
            title={t('GLOBAL.SELECT_ALL')}
          >
            <span className='fa fa-check-square mx-1'></span>
          </button>

          <button
            className='btn btn-warning btn-sm w-25 fw-bold'
            onClick={selectProps.deselectAllHandler}
            title={t('BUTTONS.DESELECT_ALL')}
          >
            <span className='fa fa-square mx-1'></span>
          </button>
        </div>
      </div>
      <components.MenuList {...props}>{children}</components.MenuList>
    </div>
  )
}

export default CustomMenuList
